import { render, staticRenderFns } from "./TheAdminContainer.vue?vue&type=template&id=c0f7a3be&scoped=true"
import script from "./TheAdminContainer.vue?vue&type=script&lang=js"
export * from "./TheAdminContainer.vue?vue&type=script&lang=js"
import style0 from "./TheAdminContainer.vue?vue&type=style&index=0&id=c0f7a3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f7a3be",
  null
  
)

export default component.exports